/*
 * lib.js
 */

define(
        'lib',
        [],
        function () {
            "use strict";

            // Checks if the argument variable is empty
            // undefined, null, false, number 0, empty string,
            // string "0", objects without properties and empty arrays
            // are considered empty
            //
            // http://kevin.vanzonneveld.net
            // +   original by: Philippe Baumann
            // +      input by: Onno Marsman
            // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +      input by: LH
            // +   improved by: Onno Marsman
            // +   improved by: Francesco
            // +   improved by: Marc Jansen
            // +      input by: Stoyan Kyosev (http://www.svest.org/)
            // +   improved by: Rafal Kukawski
            // *     example 1: empty(null);
            // *     returns 1: true
            // *     example 2: empty(undefined);
            // *     returns 2: true
            // *     example 3: empty([]);
            // *     returns 3: true
            // *     example 4: empty({});
            // *     returns 4: true
            // *     example 5: empty({'aFunc' : function () { alert('humpty'); } });
            // *     returns 5: false
            function empty(mixed_var)
            {
                var undef, key, i, len;
                var emptyValues = [undef, null, false, 0, "", "0"];

                for (i = 0, len = emptyValues.length; i < len; i++) {
                    if (mixed_var === emptyValues[i]) {
                        return true;
                    }
                }

                if (typeof mixed_var === "object") {
                    for (key in mixed_var) {
                        // TODO: should we check for own properties only?
                        //if (mixed_var.hasOwnProperty(key)) {
                        return false;
                        //}
                    }
                    return true;
                }

                return false;
            }

            function uniqid()
            {
                console.warn("ServiceMaint : Cette fonction est depréciée");

                var ts = String(new Date().getTime()), i = 0, out = '';
                for (i = 0; i < ts.length; i += 2) {
                    out += Number(ts.substr(i, 2)).toString(36);
                }
                return ('d' + out);
            }

            /**
             * Gérer les quotes
             * @param {string} str Texte à analyser
             * @returns {String} Texte modifié
             */
            function addslashes(str)
            {
                //  discuss at: http://phpjs.org/functions/addslashes/
                // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
                // improved by: Ates Goral (http://magnetiq.com)
                // improved by: marrtins
                // improved by: Nate
                // improved by: Onno Marsman
                // improved by: Brett Zamir (http://brett-zamir.me)
                // improved by: Oskar Larsson Högfeldt (http://oskar-lh.name/)
                //    input by: Denny Wardhana
                //   example 1: addslashes("kevin's birthday");
                //   returns 1: "kevin\\'s birthday"

                return (str + '')
                        .replace(/[\\"']/g, '\\$&')
                        .replace(/\u0000/g, '\\0');
            }



            function trim(str, charlist)
            {
                // From: http://phpjs.org/functions
                // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
                // +   improved by: mdsjack (http://www.mdsjack.bo.it)
                // +   improved by: Alexander Ermolaev
                //      (http://snippets.dzone.com/user/AlexanderErmolaev)
                // +      input by: Erkekjetter
                // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
                // +      input by: DxGx
                // +   improved by: Steven Levithan (http://blog.stevenlevithan.com)
                // +    tweaked by: Jack
                // +   bugfixed by: Onno Marsman
                // *     example 1: trim('    Kevin van Zonneveld    ');
                // *     returns 1: 'Kevin van Zonneveld'
                // *     example 2: trim('Hello World', 'Hdle');
                // *     returns 2: 'o Wor'
                // *     example 3: trim(16, 1);
                // *     returns 3: 6
                var whitespace;
                str += '';

                if (!charlist) {
                    // default list
                    whitespace = " \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000";
                } else {
                    // preg_quote custom list
                    charlist += '';
                    whitespace = charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '$1');
                }
                var l = str.length;
                for (var i = 0; i < l; i++) {
                    if (whitespace.indexOf(str.charAt(i)) === -1) {
                        str = str.substring(i);
                        break;
                    }
                }

                l = str.length;
                for (i = l - 1; i >= 0; i--) {
                    if (whitespace.indexOf(str.charAt(i)) === -1) {
                        str = str.substring(0, i + 1);
                        break;
                    }
                }

                return whitespace.indexOf(str.charAt(0)) === -1 ? str : '';
            }

            /**
             * Return default value if the value is null
             * @param {string} value1 Valeur initiale
             * @param {string} value2 Valeur par défaut
             * @returns {string} Valeur retenue
             */
            function nvl(value1, value2)
            {
                if (value1 === null || value1 === '') {
                    return value2;
                }
                return value1;
            }

            function json2array(json)
            {
                var result = [];
                var keys = Object.keys(json);
                keys.forEach(function (key) {
                    if ((json[key] !== null) && (typeof json[key] === "object")) {
                        var newResult = json2array(json[key]);
                        for (var i = 0; i < newResult.length; i++) {
                            var elem = [];
                            elem.push(newResult[i][0]);
                            elem.push(newResult[i][1]);
                            result.push(elem);
                        }
                    } else {
                        var elem = [];
                        elem.push(key);
                        elem.push(json[key]);
                        result.push(elem);
                    }
                });
                return result;
            }

            //    exposed public method
            return {
                empty: empty,
                uniqid: uniqid,
                addslashes: addslashes,
                trim: trim,
                nvl: nvl,
                json2array: json2array
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);
